var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 926,
    viewBox: "0 0 428 926",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5946_1446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 437,
    width: 428,
    height: 489
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428 437H0V926H428V437Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5946_1446)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M437.942 429.101L106.942 668.643V1197.48L437.942 957.942V429.101Z",
    fill: "url(#paint0_linear_5946_1446)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5946_1446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 437,
    width: 428,
    height: 489
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M428 437H0V926H428V437Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5946_1446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.337891 728.694L180.765 859.268V1147.54L0.337891 1016.96V728.694Z",
    fill: "url(#paint1_linear_5946_1446)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5946_1446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 437,
    width: 428,
    height: 489
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M428 437.086H0V926H428V437.086Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5946_1446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.891 764.163L312.837 761.156V455.325L310.891 458.331V764.163Z",
    fill: "#70B5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.061 771.741L301.008 768.735V462.903L299.061 465.91V771.741Z",
    fill: "#76BAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.23 779.32L289.179 776.314V470.482L287.23 473.488V779.32Z",
    fill: "#7DBEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.401 786.899L277.348 783.893V478.061L275.401 481.067V786.899Z",
    fill: "#83C3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.573 794.478L265.52 791.471V485.64L263.573 488.646V794.478Z",
    fill: "#89C8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.743 802.056L253.691 799.05V493.219L251.743 496.225V802.056Z",
    fill: "#90CDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.912 809.635L241.861 806.629V500.797L239.912 503.804V809.635Z",
    fill: "#96D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.083 817.214L230.03 814.208V508.376L228.083 511.382V817.214Z",
    fill: "#9DD6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.255 824.794L218.202 821.786V515.955L216.255 518.961V824.794Z",
    fill: "#A3DBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.423 832.372L206.373 829.365V523.534L204.423 526.54V832.372Z",
    fill: "#A9E0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.594 839.95L194.542 836.945V531.112L192.594 534.119V839.95Z",
    fill: "#B0E4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.765 847.53L182.713 844.523V538.691L180.765 541.697V847.53Z",
    fill: "#B6E9FD"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5946_1446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 428,
    height: 489
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 489H428V0H0V489Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5946_1446)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M-9.94189 496.899L321.058 257.357V-271.484L-9.94189 -31.9418V496.899Z",
    fill: "url(#paint2_linear_5946_1446)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5946_1446",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 428,
    height: 489
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 489H428V0H0V489Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5946_1446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.662 197.306L247.235 66.7317V-221.536L427.662 -90.9644V197.306Z",
    fill: "url(#paint3_linear_5946_1446)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5946_1446",
    x1: 144.822,
    y1: 813.293,
    x2: 512.087,
    y2: 813.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5494C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5946_1446",
    x1: 160.117,
    y1: 938.116,
    x2: -40.0784,
    y2: 938.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5494C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5946_1446",
    x1: 283.178,
    y1: 112.707,
    x2: -84.0871,
    y2: 112.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5494C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5946_1446",
    x1: 267.883,
    y1: -12.1156,
    x2: 468.078,
    y2: -12.1156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5494C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBgMobile);
export default __webpack_public_path__ + "static/media/login_bg_mobile.112fe14e1ae04c5f2d7e11f5fa061f30.svg";
export { ForwardRef as ReactComponent };